export function toHtmlDate(date: Date) {
	const day = ('0' + date.getDate()).slice(-2);
	const month = ('0' + (date.getMonth() + 1)).slice(-2);

	const formattedDate = date.getFullYear() + '-' + month + '-' + day;

  return formattedDate;
}

export function readableTimeFromNow(date: Date): string {
	const now = new Date();
	const diff = date.getTime() - now.getTime(); // difference in milliseconds
	const absDiff = Math.abs(diff);

	// Calculate time units
	const seconds = Math.floor(absDiff / 1000);
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	// Format the result
	let result = '';

	if (days > 0) {
		result = `${days} day${days > 1 ? 's' : ''}`;
	} else if (hours > 0) {
		result = `${hours} hour${hours > 1 ? 's' : ''}`;
	} else if (minutes > 0) {
		result = `${minutes} min`;
	} else if (seconds > 0) {
		result = `${seconds} sec`;
	} else {
		// For cases where the difference is less than a second
		return 'now';
	}

	// Prefix with "in" for future dates, "ago" for past dates
	return diff > 0 ? `in ${result}` : `${result} ago`;
}


export function getMonthRange(referenceDate: Date): {
	startDate: Date;
	endDate: Date;
} {
	const year = referenceDate.getFullYear();
	const month = referenceDate.getMonth();
	const dayOfTheMonth = 1;

	const timezoneMinutesOffset = new Date(
		year,
		month,
		dayOfTheMonth
	).getTimezoneOffset();
	const timezoneHoursOffset = timezoneMinutesOffset / 60;

	// We turn the current hours offset into an opposite number (positive to negative, or negative to positive)
	// So it can be used to corrent for the offset and get the actual date value we need
	const offset = timezoneHoursOffset * -1;

	// Calculate the first day of the next month
	const firstDayOfNextMonth = new Date(year, month, dayOfTheMonth, offset);

	// Calculate the last day of the month
	const lastDay = new Date(year, month + 1, 0, offset);

	return {
		startDate: firstDayOfNextMonth,
		endDate: lastDay,
	};
}

export function daysUntil(targetDate: Date): number {
	const currentDate = new Date();
	const timeDifference = targetDate.getTime() - currentDate.getTime();
	const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
	return daysDifference;
}

export function firstDayOfCurrentMonth(): Date {
	const currentDate = new Date();
	const year = currentDate.getFullYear();
	const month = currentDate.getMonth();
	const dayOfTheMonth = 1;

	const timezoneMinutesOffset = new Date(
		year,
		month,
		dayOfTheMonth
	).getTimezoneOffset();
	const timezoneHoursOffset = timezoneMinutesOffset / 60;

	// We turn the current hours offset into an opposite number (positive to negative, or negative to positive)
	// So it can be used to corrent for the offset and get the actual date value we need
	const offset = timezoneHoursOffset * -1;

	const resultDate = new Date(year, month, dayOfTheMonth, offset);

	return resultDate;
}

export function firstDayOfNextMonth(): Date {
	const currentDate = new Date();
	const year = currentDate.getFullYear();
	const month = currentDate.getMonth() + 1;
	const dayOfTheMonth = 1;

	const timezoneMinutesOffset = new Date(
		year,
		month,
		dayOfTheMonth
	).getTimezoneOffset();
	const timezoneHoursOffset = timezoneMinutesOffset / 60;

	// We turn the current hours offset into an opposite number (positive to negative, or negative to positive)
	// So it can be used to corrent for the offset and get the actual date value we need
	const offset = timezoneHoursOffset * -1;

	// Calculate the first day of the next month
	const firstDayOfNextMonth = new Date(year, month, dayOfTheMonth, offset);

	return firstDayOfNextMonth;
}

export function formatDateShort(date: Date): string {
	const months = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];

	const month = months[date.getMonth()];
	const day = date.getDate();

	return `${month} ${day}`;
}

export function calculatePercentageDifference(
	num1: number,
	num2: number
): number | null {
	if (num1 === 0) {
		// Avoid division by zero if num1 is 0.
		if (num2 === 0) {
			return 0; // Both numbers are the same.
		} else {
			return 100; // Treat as a 100% increase from 0 to num2.
		}
	}

	const difference = num2 - num1;
	const percentageDifference = (difference / num1) * 100;

	return percentageDifference;
}

// Returns a date in "YYYY-MM-DD" format
export function formatDate(date: Date): string {
	return date.toISOString().split('T')[0];
}
